// extracted by mini-css-extract-plugin
export default {"container":"styles_container__o1Zi9","title":"styles_title__Ep9AS","subtitle":"styles_subtitle__2PGAG","footer":"styles_footer__ziMGb","link":"styles_link__Tk+ZH"};